module.exports = __webpack_public_path__ + "img/CLS-P-230.6675f546.svg";